import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { userAPI, authAPI } from '../../services/api';

const SUPPORT_PHONE = '+91 99103 73510';
const SUPPORT_TEL   = '+919910373510';

export default function PendingApproval() {
  const { user, updateUser, logout } = useAuth();
  const navigate = useNavigate();

  // Auto-detect approval: ping /user/me on mount; if active, jump to dashboard.
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await userAPI.me();
        const fresh = res?.data?.user;
        if (!cancelled && fresh) {
          updateUser({ ...user, ...fresh });
          if (fresh.account_status === 'active') {
            navigate('/user/dashboard', { replace: true });
          }
        }
      } catch (_) { /* silent */ }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogout = async () => {
    try { await authAPI.logout(); } catch (_) {}
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.icon}>⏳</div>
        <h1 style={styles.title}>Account under review</h1>
        <p style={styles.body}>
          Thanks for signing up. Our team will reach out to you shortly to complete the
          onboarding. You'll get full access to your panel once that's done.
        </p>

        <div style={styles.contactBox}>
          <div style={styles.contactLabel}>Need help right away?</div>
          <a href={`tel:${SUPPORT_TEL}`} style={styles.phone}>{SUPPORT_PHONE}</a>
          <div style={styles.hint}>Call us between 10:00 AM and 7:00 PM IST.</div>
        </div>

        <button onClick={handleLogout} style={styles.btn}>Sign out</button>

        {user?.email && (
          <div style={styles.signedInAs}>Signed in as <strong>{user.email}</strong></div>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: 24, background: 'linear-gradient(135deg, #14142b 0%, #1E293B 100%)',
    fontFamily: '"Plus Jakarta Sans", system-ui, -apple-system, Arial, sans-serif',
  },
  card: {
    width: '100%', maxWidth: 520, background: '#fff', borderRadius: 16,
    padding: 40, boxShadow: '0 20px 60px rgba(0,0,0,.25)', textAlign: 'center',
  },
  icon: { fontSize: 48, marginBottom: 8 },
  title: { fontSize: 26, margin: '8px 0 12px', color: '#14142b', fontWeight: 700 },
  body:  { color: '#4a4a6a', lineHeight: 1.55, marginBottom: 24 },
  contactBox: {
    background: '#f9f9fc', border: '1px solid #e8e8f1', borderRadius: 14,
    padding: 20, marginBottom: 24,
  },
  contactLabel: { fontSize: 13, color: '#4a4a6a', marginBottom: 6 },
  phone: { display: 'inline-block', fontSize: 24, fontWeight: 700, color: '#14142b', textDecoration: 'none' },
  hint:  { fontSize: 12, color: '#6e6e86', marginTop: 6 },
  btn: {
    background: '#14142b', color: '#fff', border: 0, borderRadius: 10,
    padding: '10px 20px', fontSize: 14, cursor: 'pointer',
  },
  signedInAs: { marginTop: 20, fontSize: 12, color: '#6e6e86' },
};
